export default __webpack_public_path__ + "static/media/hht2_ep18_speaking_03.28a8025a.png";